import React from "react"
import propTypes from "prop-types"

import Button from "../../../../components/Button"
import Card, { Title, Description } from "../Card"
import InfoCard, {
  InfoCardItem,
  InfoCardTitle,
  InfoCardDescription,
  InfoCardEdit,
  InfoCardLabel,
  InfoCardSubtitle,
  InfoCardFile
} from "../InfoCard"

const OneOffPurchasesCard = ({
  services,
  onFormOpen,
  removeItem,
  goals,
  editLink,
  hideDelete
}) => {
  return (
    <Card className="card--yellow-light">
      <Title>One off Purchases</Title>
      <Description>
        You can Request technology and equipment that you need to buy to help
        manage your disability
      </Description>

      <div className="row">
        {services.map(service => {
          return (
            <div key={service.id} className="col-md-10 col-lg-6">
              <InfoCard
                hideDelete={hideDelete}
                onDelete={() => {
                  removeItem(service.id)
                }}
              >
                <div className="row">
                  <div className="col-md-6">
                    <InfoCardItem>
                      <InfoCardLabel>Service</InfoCardLabel>
                      <InfoCardTitle>{service.title}</InfoCardTitle>
                    </InfoCardItem>
                  </div>

                  <div className="col-md-6">
                    <InfoCardItem>
                      <InfoCardLabel>Price Range EST.</InfoCardLabel>
                      <InfoCardTitle>
                        ${service.item.lower} - ${service.item.upper}
                      </InfoCardTitle>
                      {service.item.unknown_price && (
                        <InfoCardDescription>
                          <em>Not sure of cost.</em>
                        </InfoCardDescription>
                      )}
                    </InfoCardItem>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <InfoCardItem>
                      <InfoCardLabel>Associated Goals</InfoCardLabel>
                      {goals.map((goal, index) => {
                        const key = `goal-${index}`

                        return service.goals.map(sGoal => {
                          if (goal.id === sGoal.id) {
                            return (
                              <InfoCardSubtitle key={key}>
                                {goal.title}
                              </InfoCardSubtitle>
                            )
                          }
                          return null
                        })
                      })}
                    </InfoCardItem>
                  </div>
                  <div className="col-md-6">
                    <InfoCardItem>
                      <InfoCardLabel>Documents</InfoCardLabel>

                      {service.documents.map((file, index) => {
                        const key = `file-${service.bestFitsRequiredService}-${index}`
                        return <InfoCardFile file={file} key={key} />
                      })}
                    </InfoCardItem>
                  </div>
                </div>
                <div className="info-card_btns-group">
                  {editLink ? (
                    <>
                      <Button
                        routerLink={{
                          to: `/pre-plan/add-a-service/${service.id}`
                        }}
                        className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Request Support
                      </Button>

                      <InfoCardEdit
                        href={`/pre-plan/add-a-service/${service.id}`}
                      >
                        Edit
                      </InfoCardEdit>
                    </>
                  ) : (
                    <>
                      <Button
                        button={{ type: "button" }}
                        onClick={e => {
                          onFormOpen(e, service.id, 1)
                        }}
                        className="btn--cancel-light btn--request-support btn--width-md btn--height-sm btn--font-size-md"
                      >
                        Request Support
                      </Button>

                      <InfoCardEdit
                        onClick={e => {
                          onFormOpen(e, service.id, 1)
                        }}
                        href="/#"
                      >
                        Edit
                      </InfoCardEdit>
                    </>
                  )}
                </div>
              </InfoCard>
            </div>
          )
        })}
      </div>
    </Card>
  )
}

OneOffPurchasesCard.defaultProps = {
  onFormOpen: () => {},
  removeItem: () => {},
  hideDelete: false,
  editLink: false
}

OneOffPurchasesCard.propTypes = {
  onFormOpen: propTypes.func,
  removeItem: propTypes.func,
  hideDelete: propTypes.bool,
  editLink: propTypes.bool,
  services: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.oneOfType([propTypes.number, propTypes.string]),
      requiredService: propTypes.string,
      bestFitsRequiredService: propTypes.string,
      lowGuess: propTypes.string,
      highGuess: propTypes.string,
      cost: propTypes.bool,
      goals: propTypes.arrayOf(propTypes.shape({})),
      files: propTypes.arrayOf(propTypes.shape({}))
    })
  ).isRequired,
  goals: propTypes.arrayOf(propTypes.shape({})).isRequired
}

export default OneOffPurchasesCard
